<script setup lang="ts">
import type { StoryblokRichTextNode } from '@storyblok/vue'
import { StoryblokComponent, StoryblokRichText } from '@storyblok/vue'

interface Props {
  blok: {
    title: StoryblokRichTextNode
    description?: StoryblokRichTextNode
    body?: any[]
  }
}
defineProps<Props>()

const theme = useTheme()
</script>

<template>
  <div v-editable="blok" p="y-8 x-4 md:y-12 md:x-6 lg:y-[60px] xl:y-[120px]" col center gap="4 md:8 lg:12" w-full>
    <div w-full max-w="1024px" mx-auto flex="~ col lg:row" items="lg:center" justify="center lg:between" gap="4 lg:60px">
      <StoryblokRichText :doc="blok.title" />
      <div max-w="438px" :style="{ color: theme.colors.softBlack }">
        <StoryblokRichText v-if="blok.description" :doc="blok.description" />
      </div>
    </div>

    <div grid="~ lg:cols-2" gap-4 w-full max-w="2048px">
      <div
        v-for="section, index in blok.body" :key="section._uid"
        :class="{
          'col-span-2': blok.body && blok.body.length % 2 !== 0 && index === blok.body.length - 1,
        }"
      >
        <StoryblokComponent :blok="section" />
      </div>
    </div>
  </div>
</template>
